import SicCodesMapping from "../../../mappings_dir/sic_codes.json";

export const SIC_CODES: { [key: string]: string } =
  SicCodesMapping.sic_codes as { [key: string]: string };
